import { useNavigationOptions } from 'app/hooks/navigation';
import type { SpecificNavigationProp } from 'app/types/navigation';

import { Button as PaperButton } from 'react-native-paper';
import { createTheme as createDSTheme } from 'app/shopify';
import { IconChevronLeft, IconX } from '@tabler/icons-react-native';
import { ICON_STROKE_WIDTH } from 'app/utils/constants';
const theme = createDSTheme();

export function useContactInformationHeaderOptions(
  navigation: SpecificNavigationProp<'contact-information'>,
  args: { headerVariant?: 'overlay' | 'standard'; hideCross?: boolean; onBackPress: () => void; step: number },
) {
  const { headerVariant = 'overlay', hideCross, onBackPress, step } = args;
  const isOverlay = headerVariant === 'overlay';
  const iconColor = isOverlay ? theme.colors['surface.default'] : theme.colors['text.primary'];

  const options = {
    headerBackVisible: false,
    headerLeft: () =>
      step > 0 ? (
        <PaperButton onPress={onBackPress}>
          <IconChevronLeft strokeWidth={ICON_STROKE_WIDTH} color={iconColor} />
        </PaperButton>
      ) : !hideCross ? (
        <PaperButton onPress={navigation.goBack}>
          <IconX strokeWidth={ICON_STROKE_WIDTH} color={iconColor} />
        </PaperButton>
      ) : null,
    headerTintColor: iconColor,
    headerTransparent: isOverlay,
  };

  useNavigationOptions(navigation, options);
}
